import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  TableProps,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import * as React from "react";
import { FiDelete, FiEdit2, FiXCircle } from "react-icons/fi";
import { IoArrowDown } from "react-icons/io5";
import { members } from "./data";
import { KYDEvent } from "@common/interfaces/KYDEvent";
import { Navigate, useNavigate } from "react-router-dom";
import { IKYDUser } from "@common/interfaces/KYDUser";
import { CognitoUser } from "amazon-cognito-identity-js";

export const AdminsTable = ({
  admins,
  onRemoveAdmin,
  loading,
  currentUser,
  ...props
}: {
  admins: IKYDUser[];
  loading: any;
  onRemoveAdmin: (userId: string) => void;
  currentUser: CognitoUser | null;
}) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    console.log("Current User: ", currentUser?.getUsername());
  }, [currentUser]);
  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Phone</Th>
          <Th>Email</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {admins.map((member: IKYDUser) => (
          <Tr key={member.id}>
            <Td>
              <HStack spacing="3">
                <Box>
                  <Text fontWeight="medium">
                    {`${member.first_name} ${member.last_name} ${
                      currentUser &&
                      currentUser.getUsername() === member.phone_number
                        ? " (You)"
                        : ""
                    }`}
                  </Text>
                </Box>
              </HStack>
            </Td>
            <Td>
              <Text color="muted">{member.phone_number}</Text>
            </Td>
            <Td>
              <Text color="muted">{member.email}</Text>
            </Td>

            <Td>
              <HStack spacing="1">
                {currentUser &&
                  currentUser.getUsername() !== member.phone_number && (
                    <IconButton
                      isDisabled={loading.remove_admin}
                      isLoading={loading[member.id]}
                      onClick={() => onRemoveAdmin(member.id)}
                      icon={<FiXCircle fontSize="1.25rem" />}
                      variant="ghost"
                      aria-label="Delete admin"
                    />
                  )}
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
